module.exports = __webpack_public_path__ + "static/media/ser_iri_wat_wat_mai.fbbfea1c.png";